export const INFORMATION_TYPE = {
  IMPORTANT: "important",
  SYSTEM: "system",
  TENANT: "tenant",
};

export const CONVERT_STATUS = {
  COMPLETE: "complete",
  IN_PROGRESS: "in_progress",
  ERROR: "error",
  CANCEL: "cancel",
};

export const DOCUMENT_KEYS = {
  ACCEPTANCE_ACTIVITY: "acceptance_activity",
  LIFE_SUPPORT: "life_support",
  ANY_TIME: "any_time",
  RETIREMENT: "retirement",
};

export const DOCUMENT_STEP_KEYS = {
  ACCEPTANCE_ACTIVITY_CREATE_DOCUMENT: "acceptance_activity_create_document",
  ACCEPTANCE_ACTIVITY_UPLOAD_DOCUMENT: "acceptance_activity_upload_document",
  ACCEPTANCE_ACTIVITY_SUBMIT: "acceptance_activity_submit",
  LIFE_SUPPORT_CREATE_DOCUMENT: "life_support_create_document",
  LIFE_SUPPORT_CONFIRM_DISCUSSION_RECORD: "life_support_confirm_discussion_record",
  LIFE_SUPPORT_SUBMIT: "life_support_activity_submit",
};

export const USER_ACTIVE_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};

/** General-purpose enabled/disabled status label for reuse across features */
export const STATUS_LABEL = {
  ENABLED: "公開",
  DISABLED: "無効",
  PRIVATE: "非公開",
  ENDED: "終了",
} as const;

/** Button labels for publishing actions */
export const ACTION_LABEL = {
  CONTENT_PUBLISHED: "コンテンツ公開",
  INDUSTRY_PUBLISHED: "受験分野を公開",
  INDUSTRY_UNPUBLISHED: "受験分野を非公開",
} as const;

export const USER_AUTH_STATUS = {
  EMAIL_SENT: "登録メール送付済み",
  PASSWORD_SET: "パスワード設定済み",
  PASSWORD_RESET: "パスワードリセット済み",
  USER_SUSPENDED: "ユーザー停止中",
};

export const USER_AUTH_STATUS_LABEL: Record<string, string> = {
  [USER_AUTH_STATUS.EMAIL_SENT]: "登録メール送付済み",
  [USER_AUTH_STATUS.PASSWORD_SET]: "パスワード設定済み",
  [USER_AUTH_STATUS.PASSWORD_RESET]: "パスワードリセット済み",
  [USER_AUTH_STATUS.USER_SUSPENDED]: "ユーザー停止中",
};

export const ATTACHED_DOCUMENT_COLOR_NAME = {
  ERROR: "error",
  PURPLE: "purple",
  DEEP_PURPLE: "deep_purple",
  PROGRESS: "progress",
  LIGHT_BLUE: "light_blue",
  TEAL: "teal",
  SUCCESS: "success",
  LIGHT_GREEN: "light_green",
  INCOMPLETE: "incomplete",
  YELLOW: "yellow",
  UNCREATED: "uncreated",
  NORMAL: "normal",
};

export const ATTACHED_DOCUMENT_COLOR = {
  [ATTACHED_DOCUMENT_COLOR_NAME.ERROR]: {
    bgColor: "#FFCDD2",
    color: "#2E3436",
  },
  [ATTACHED_DOCUMENT_COLOR_NAME.PURPLE]: {
    bgColor: "#E1BEE7",
    color: "#2E3436",
  },
  [ATTACHED_DOCUMENT_COLOR_NAME.DEEP_PURPLE]: {
    bgColor: "#D1C4E9",
    color: "#2E3436",
  },
  [ATTACHED_DOCUMENT_COLOR_NAME.PROGRESS]: {
    bgColor: "#BBDEFB",
    color: "#2E3436",
  },
  [ATTACHED_DOCUMENT_COLOR_NAME.LIGHT_BLUE]: {
    bgColor: "#B3E5FC",
    color: "#2E3436",
  },
  [ATTACHED_DOCUMENT_COLOR_NAME.TEAL]: {
    bgColor: "#B2DFDB",
    color: "#2E3436",
  },
  [ATTACHED_DOCUMENT_COLOR_NAME.SUCCESS]: {
    bgColor: "#C8E6C9",
    color: "#2E3436",
  },
  [ATTACHED_DOCUMENT_COLOR_NAME.LIGHT_GREEN]: {
    bgColor: "#DCEDC8",
    color: "#2E3436",
  },
  [ATTACHED_DOCUMENT_COLOR_NAME.INCOMPLETE]: {
    bgColor: "#FFE0B2",
    color: "#2E3436",
  },
  [ATTACHED_DOCUMENT_COLOR_NAME.YELLOW]: {
    bgColor: "#FFF9C4",
    color: "#2E3436",
  },
  [ATTACHED_DOCUMENT_COLOR_NAME.UNCREATED]: {
    bgColor: "#E6E7E8",
    color: "#2E3436",
  },
  [ATTACHED_DOCUMENT_COLOR_NAME.NORMAL]: {
    bgColor: "#FFFFFF",
    color: "#2E3436",
  },
};
